/*
 * MLV free shipping gauge (EU + Monaco).
 *
 * The gauge markup is rendered by snippets/free-shipping-bar.liquid; this file
 * only registers the <free-shipping-gauge> element. It is loaded from
 * sections/cart-drawer.liquid on every page — even when the cart is empty — so
 * that gauges inserted later by Section Rendering API re-renders are upgraded
 * and keep updating on every "cart:change" event.
 *
 * The threshold-shop-cents attribute is expressed in SHOP currency (EUR) cents
 * and is converted to the active presentment currency with
 * Shopify.currency.rate, so non-euro EU markets (SEK, PLN, CZK, DKK, HUF...)
 * keep a true 150 EUR threshold.
 */
(() => {
  if (window.customElements.get('free-shipping-gauge')) {
    return;
  }

  class FreeShippingGauge extends HTMLElement {
    connectedCallback() {
      this.onCartChangeListener = this.onCartChange.bind(this);
      document.addEventListener('cart:change', this.onCartChangeListener);
      this.render(parseInt(this.getAttribute('total-price'), 10) || 0);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.onCartChangeListener);
    }

    get threshold() {
      const shopCurrencyCents = parseInt(this.getAttribute('threshold-shop-cents'), 10) || 0;
      const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;

      return Math.round(shopCurrencyCents * rate);
    }

    onCartChange(event) {
      const cart = event.detail ? event.detail.cart : null;

      if (!cart || !this.isConnected) {
        return;
      }

      const totalForShipping = cart.items
        .filter((item) => item.requires_shipping)
        .reduce((sum, item) => sum + item.final_line_price, 0);

      const cartDiscount = (cart.cart_level_discount_applications || []).reduce(
        (sum, app) => sum + app.total_allocated_amount,
        0
      );

      this.render(totalForShipping - cartDiscount);
    }

    render(totalInCents) {
      const threshold = this.threshold;

      if (!threshold) {
        return;
      }

      const total = Math.max(0, totalInCents);
      const progress = Math.min(100, (total / threshold) * 100);
      const fill = this.querySelector('[data-gauge-fill]');
      const message = this.querySelector('[data-gauge-message]');
      const reached = total >= threshold;

      this.classList.toggle('is-reached', reached);

      if (fill) {
        fill.style.width = progress.toFixed(1) + '%';
      }

      if (message) {
        if (reached) {
          message.innerHTML = this.getAttribute('reached-message');
        } else {
          const formatter = new Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
          });
          const remaining = formatter.format((threshold - total) / 100).replace(/\$/g, '$$$$');

          message.innerHTML = this.getAttribute('unreached-message').replace(/\{\{.*?\}\}/g, remaining);
        }
      }
    }
  }

  window.customElements.define('free-shipping-gauge', FreeShippingGauge);
})();
